var map = {
	"./arrow-down.svg": [
		7546,
		546
	],
	"./btn.svg": [
		3947,
		947
	],
	"./chat.svg": [
		3106,
		106
	],
	"./check.svg": [
		2335,
		335
	],
	"./heart.svg": [
		9058,
		58
	],
	"./icon-1.svg": [
		4202,
		202
	],
	"./icon-1_act.svg": [
		3230,
		230
	],
	"./icon-2.svg": [
		339,
		339
	],
	"./icon-2_act.svg": [
		5405,
		405
	],
	"./logo.svg": [
		726,
		726
	],
	"./modal-logo.svg": [
		1610,
		610
	],
	"./service-1.svg": [
		4742,
		742
	],
	"./service-1_act.svg": [
		4406,
		406
	],
	"./service-2.svg": [
		7956,
		956
	],
	"./service-2_act.svg": [
		3698,
		698
	],
	"./service-3.svg": [
		6233,
		233
	],
	"./service-3_act.svg": [
		7116,
		116
	],
	"./service-4.svg": [
		1031,
		31
	],
	"./service-4_act.svg": [
		7478,
		478
	],
	"./service-5.svg": [
		2334,
		334
	],
	"./service-5_act.svg": [
		6490,
		490
	],
	"./service-6.svg": [
		851,
		851
	],
	"./service-6_act.svg": [
		606,
		606
	],
	"./star.svg": [
		3300,
		300
	],
	"./vtr-1.svg": [
		2084,
		84
	],
	"./vtr-2.svg": [
		6589,
		589
	],
	"./vtr-3.svg": [
		122,
		122
	],
	"./vtr-4.svg": [
		695,
		695
	],
	"./vtr-5.svg": [
		4105,
		105
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3736;
module.exports = webpackAsyncContext;